// 外部联系人处理状态
export const statusList = [
  {
    value: '1',
    label: '待处理',
  },
  {
    value: '2',
    label: '处理中',
  },
  {
    value: '3',
    label: '已处理',
  },
];

// 外部联系人转移明细详情状态
export const recordStatusList = [
  {
    value: '0',
    label: '全部',
  },
  {
    value: '1',
    label: '待处理',
  },
  {
    value: '2',
    label: '成功',
  },
  {
    value: '3',
    label: '失败',
  },

];
